import { Bell, BellOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { useStore } from "@/lib/store";
import { fmtTime, fmtDay } from "@/lib/xc";

export default function ReminderMenu() {
  const { reminders, removeReminders } = useStore();
  const nav = useNavigate();
  return (
    <Popover>
      <PopoverTrigger className="relative p-2 rounded-lg border border-[#212738] hover:border-[#38425C]" data-testid="reminders-button" title="Reminders">
        <Bell className="w-4 h-4" />
        {reminders.length > 0 && (
          <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] rounded-full bg-[#E50914] text-[10px] font-mono font-bold grid place-items-center px-1" data-testid="reminders-count">
            {reminders.length}
          </span>
        )}
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 bg-[#11141F] border-[#212738] text-slate-200 p-0" data-testid="reminders-panel">
        <div className="px-4 py-3 border-b border-[#212738] font-heading font-semibold">Reminders</div>
        {!reminders.length && (
          <div className="px-4 py-6 text-sm text-slate-500" data-testid="reminders-empty">
            No reminders. Click an upcoming show in the TV guide to get alerted when it starts.
          </div>
        )}
        <div className="max-h-80 overflow-y-auto xc-scroll">
          {reminders.map((r) => (
            <div key={r.key} className="flex items-center gap-3 px-4 py-3 border-b border-[#212738] last:border-0" data-testid={`reminder-item-${r.key}`}>
              <button className="flex-1 min-w-0 text-left" onClick={() => nav("/guide")}>
                <div className="text-sm font-medium truncate">{r.title}</div>
                <div className="text-[11px] font-mono text-slate-500 truncate">
                  {fmtDay(r.start)} · {fmtTime(r.start)} · {r.channel.name}
                </div>
              </button>
              <button onClick={() => removeReminders([r.key])} className="p-1.5 rounded-md text-slate-500 hover:text-[#FF5A62] hover:bg-white/5" data-testid={`reminder-delete-${r.key}`}>
                <BellOff className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
        <div className="px-4 py-2.5 text-[11px] text-slate-500 border-t border-[#212738]">Alerts appear while XC Player is open.</div>
      </PopoverContent>
    </Popover>
  );
}
